import { fixResponseJSON, filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';
import axios from 'axios';
let url = process.env.REACT_APP_API_URL;

export const membershipService = {
  getMembership: async (searchParam) => {
    const response = await authInstance
      .get(`${url}/memberships/search?searchParam=${searchParam}&limit=10`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  selfRenew: async (data, membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/selfRenewal`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getDocumentsData: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/getDocumentsData`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getDocumentsDataV2: async (data) => {
    let develop = process.env.REACT_APP_DEVELOP;
    let url = '';
    if (develop === 'true') {
      url = process.env.REACT_APP_DOCUMENT_READER_DEVELOP;
    } else {
      url = process.env.REACT_APP_DOCUMENT_READER_PROD;
    }
    const response = axios({
      url,
      method: 'POST',
      responseType: 'application/json', // Set the response type to blob
      headers: {
        'Content-type': 'multipart/form-data',
      },
      data: data,
    })
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getPaymentsData: async (data) => {
    let url = process.env.REACT_APP_DOCUMENT_READER_PAYMENTS;
    const response = axios({
      url,
      method: 'POST',
      responseType: 'application/json', // Set the response type to blob
      headers: {
        'Content-type': 'multipart/form-data',
      },
      data: data,
    })
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  ZipRCV: async (params) => {
    axios({
      url:
        `${url}/memberships/downloadRcvDocuments?` +
        new URLSearchParams(filterParams(params)),
      method: 'GET',
      responseType: 'blob', // Set the response type to blob
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage?.getItem('accessToken')}`,
      },
    })
      .then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'zip-carga-de-flotas.zip'); // Set the desired file name
        document.body.appendChild(link);
        link.click();
        return fixResponseJSON(response);
      })
      .catch((error) => {
        console.error('Error downloading zip file:', error);
      });
  },

  ZipRCV_SCORP: async (params) => {
    axios({
      url:
        `${url}/memberships/downloadRcvSeguroCorporativo?` +
        new URLSearchParams(filterParams(params)),
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage?.getItem('accessToken')}`,
      },
    })
      .then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute(
          'download',
          'zip-documentos-seguros-corporativos.zip'
        );
        document.body.appendChild(link);
        link.click();
        return fixResponseJSON(response);
      })
      .catch((error) => {
        console.error('Error downloading zip file:', error);
      });
  },

  getMembershipById: async (membershipId, moduleType) => {
    const response = await authInstance
      .get(`${url}/memberships/${moduleType}/${membershipId}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  calculateRenewalPrice: async (params, membershipId) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage?.getItem('accessToken')}`,
      },
      method: 'GET',
    };

    const response = await fetch(
      `${url}/memberships/${membershipId}/calculateRenewal?` +
        new URLSearchParams(filterParams(params)),
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getLastServices: async (membershipId) => {
    const response = await authInstance
      .get(`${url}/services/getLatest?membership=${membershipId}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getCancelReason: async (membershipType) => {
    const response = await authInstance
      .get(
        `${url}/cancellationReasons/search?type=${membershipType}&limit=1000`
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createMembership: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
  createMassive: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/createMassive`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  sendDocuments: async (memebershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${memebershipId}/sendDocuments`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipsByStatus: async (params) => {
    const response = await authInstance
      .post(
        `${url}/memberships/findAll?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipCashea: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/casheaMemberships?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipsCountByCondition: async (params, body) => {
    const response = await authInstance
      .post(
        `${url}/memberships/countByConditions?` +
          new URLSearchParams(filterParams(params)),
        body
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getAccountsReceivable: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/getAccountsReceivable?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
  getPendingDues: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/listPendingDues`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipsCountRenewal: async (params, data) => {
    const response = await authInstance
      .post(
        `${url}/memberships/countRenewals?` +
          new URLSearchParams(filterParams(params)),
        data
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getRCVs: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/getRcv?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  upgradeMembership: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${memebershipId}/upgrade`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  addRCV: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${memebershipId}/addRCV`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  addMedicalCert: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${memebershipId}/addMedicalCert`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  addRcvCard: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${memebershipId}/addRcvCard`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  upgradeMembershipPaymet: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${memebershipId}/payments`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  changeCustomer: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/changeCustomer`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  changeVehicle: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/changeVehicle`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getAdminTableData: async (params) => {
    const response = await authInstance
      .get(
        `${url}/payments/exportableAdmin?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getRCVSeguroCorporativo: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/getRcvSeguroCorporativo?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipsToBeRenewed: async (params, data) => {
    const response = await authInstance
      .post(
        `${url}/memberships/findAllRenewal?` +
          new URLSearchParams(filterParams(params)),
        data
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipCountByStatus: async (searchParam) => {
    const response = await authInstance
      .get(`${url}/memberships/totalByStatus`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateMembershipStatus: async (membershipId, body) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(body),
      method: 'PUT',
    };

    const response = await fetch(
      `${url}/memberships/${membershipId}/updateStatus`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updatePaymentTypeInRenewal: async (membershipId, data) => {
    const response = await authInstance
      ?.put(`${url}/memberships/${membershipId}/paymentType`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getSalesMembershipById: async (membershipId) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'GET',
    };

    const response = await fetch(
      `${url}/memberships/sales/${membershipId}`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateImages: async (file, membershipId, payment) => {
    const myInit = {
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'PUT',
      body: file,
    };

    const paymentPath = payment ? `/${payment}` : '';
    const response = await fetch(
      `${url}/memberships/${membershipId}/updateImages${paymentPath}`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateMembership: async (data, membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/update`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  loadInvoiceNumber: async (data, membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/loadInvoiceNumber`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  approveMembership: async (membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/approve`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
  cancelMembership: async (data, membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/cancel`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  renewMembership: async (membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/renew`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getStatuses: async () => {
    const response = await authInstance
      .get(`${url}/memberships/status`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  changeAnnullationReason: async (data, membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/changeAnnullationReason`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  reativateMembership: async (membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/reactivate`, {})
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
  rescueMembership: async (membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/rescue`, {})
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  removeCode: async (membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/removeCode`, {})
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updatePaymentDues: async (data, membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/updatePaymentDues`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  updateFromGrid: async (membershipId, data) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/updateFromGrid`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateTransferTo: async (membershipId, data) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/updateTransferTo`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  renewFilterOptions: async (params, data) => {
    const response = await authInstance
      .post(
        `${url}/memberships/renewalFilterOptions?` +
          new URLSearchParams(filterParams(params)),
        data
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  listFilterOptions: async (params, data) => {
    const response = await authInstance
      .post(
        `${url}/memberships/listFilterOptions?` +
          new URLSearchParams(filterParams(params)),
        data
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  sendCasheaReconcileFile: async (data) => {
    const response = await authInstance
      .post(`${url}/cashea/reconcile`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  sendCasheaFactoringFile: async (data) => {
    const response = await authInstance
      .post(`${url}/cashea/factoring`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  editPaymentType: async (membershipId, data) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/paymentTypeAndPayments`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  createMassiveCustomerVehicle: async (data) => {
    const myInit = {
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'POST',
      body: data,
    };

    const response = await fetch(
      `${url}/memberships/createMassiveCustomerVehicle`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  addToCart: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/renewalCart`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  removeFromCart: async (membershipId) => {
    const response = await authInstance
      .delete(`${url}/memberships/renewalCart/${membershipId}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getRenewalCart: async (searchParam) => {
    const response = await authInstance
      .get(`${url}/memberships/renewalCart`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateRenewalCart: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/renewalCart/${memebershipId}`, data)
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipsForApproval: async (params, body) => {
    const response = await authInstance
      .post(
        `${url}/memberships/findAll?` +
          new URLSearchParams(filterParams(params)),
        body
      )
      .then(async (response) => {
        return response;
      });
    return response;
  },

  getPrintableMembership: async (id) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
      },
      method: 'GET',
    };

    const response = await fetch(
      `${url}/memberships/${id}/getMembershipRCV`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response);
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getMembershipsByType: async (params, body) => {
    const response = await authInstance
      .post(
        `${url}/memberships/ListBase?` +
          new URLSearchParams(filterParams(params)),
        body
      )
      .then(async (response) => {
        return response;
      });
    return response;
  },

  getSalesExportable: async (params, body) => {
    const response = await authInstance
      .post(
        `${url}/memberships/ListSales?` +
          new URLSearchParams(filterParams(params)),
        body
      )
      .then(async (response) => {
        return response;
      });
    return response;
  },

  getUpgradesExportable: async (params, body) => {
    const response = await authInstance
      .post(
        `${url}/memberships/listUpgrade?` +
          new URLSearchParams(filterParams(params)),
        body
      )
      .then(async (response) => {
        return response;
      });
    return response;
  },
};
